const AbstractView = require("../common/AbstractView");

/**
 * View for displaying the listing of a VFS directory
 *
 * @constructor
 * @implements AbstractView
 */
let count = 0;

function VFSDirectoryListView() {
    let idSuffix = count++;

    const self = this;

    const $listview = $('<ul class="vfsDirectoryList" data-role="listview" data-filter="false" data-inset="false">');
    const $uploadButton = $('<a href="#" rel="external" data-role="button" data-icon="mobile-upload" data-iconpos="notext" data-inline="true">');
    const $createFolderButton = $('<a href="#" rel="external" data-role="button" data-icon="mobile-createfolder" data-iconpos="notext" data-inline="true">');
    const $deleteButton = $('<a href="#" rel="external" data-role="button" data-icon="mobile-delete" data-iconpos="notext" data-inline="true">');
    const $renameButton = $('<a href="#" rel="external" data-role="button" data-icon="mobile-rename" data-iconpos="notext" data-inline="true">');
    const $emptyDirMessage = $('<div class="vfsEmptyDirMessage" data-i18n="common::vfs.emptyDir.message">');
    const $content = $('<div class="pullToRefresh">')
        .append($('<div class="vfsDirectoryListContainer">')
            .append($listview)
            .append($emptyDirMessage));

    let title = "";
    let currentPath = "";

    function buildPath() {
        return (currentPath.substring(currentPath.length - 1) === "/")
            ? currentPath
            : currentPath + "/";
    }

    $uploadButton.on("click", function() {
        self.publishEvent("VFSController", "upload-files", {
            targetDir : buildPath()
        });
    });

    $createFolderButton.on("click", function() {
        self.publishEvent("VFSController", "show-create-folder-dialog", {
            targetDir : buildPath()
        });
    });

    $deleteButton.on("click", function() {
        self.publishEvent("VFSController", "delete-file-folder", {
            target : currentPath
        });
    });

    $renameButton.on("click", function() {
        self.publishEvent("VFSController", "show-rename-dialog", {
            target : currentPath
        });
    });

    $content.on("refresh", function() {
        self.publishEvent("VFSController", "refresh-directory-list", {
            target : currentPath
        });
    });

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "VFSDirectoryList" + idSuffix;
    };

    /**
     *
     * @returns {string} The current path
     */
    this.getPath = function() {
        return currentPath;
    };

    /**
     * @override
     * @returns {jQuery} The jQuery element containing the content of this view
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @returns {DefaultHeader~Configuration} The header configuration for this view
     */
    this.getHeaderConfiguration = function() {
        const isRoot = title === "/";
        let rightButtons = [];
        let overflowButtons = {};

        if (isRoot) {
            rightButtons = [$createFolderButton, $uploadButton];
        } else {
            overflowButtons = {
                "common::vfs.renameFileFolder.title" : $renameButton,
                "common::vfs.deleteConfirmation.title" : $deleteButton,
                "common::vfs.createButton.title" : $createFolderButton,
                "common::vfs.uploadFiles.title" : $uploadButton
            };
        }

        return {
            title : title,
            disableBackButton : isRoot,
            rightButtons : rightButtons,
            overflowButtons : overflowButtons,
            overflowClasses : "vfsHeader"
        };
    };

    /**
    * @param _title {string} Sets the title of this view
    */
    this.setTitle = function(_title) {
        title = _title === "" ? "/" : _title;
    };

    /**
     * Configures the view to display the contents of the directory provided.
     * Clicking one of the generated items in the DOM will fire the show-directory-list or the show-file-actions event for the corresponding file/folder
     *
     * @param {Directory} dir - An object representing the directory to be displayed
     * @param {Array<File>} dirContents - The list of files and folders to be displayed in the view
     * @param {boolean=} append - whether to append to the current contents (e.g. loading more files due to scrolling) or not
     */
    this.setDirContents = function(dir, dirContents, append) {
        const path = dir.getPath();
        currentPath = path;

        if (!append) {
            $listview.empty();
        }

        let isEmpty = true;

        for (let i = 0; i < dirContents.length; i++) {
            const item = dirContents[i];
            const itemName = item.name;

            const $item = $("<li>", {"data-theme" : "a"})
                .append($("<a>", {
                    href : "#",
                    text : itemName,
                    title : itemName
                }));

            const _path = path === "/" ? path : path + "/";

            if (item.isDirectory) {
                $item.attr("data-filetype", "folder");

                $item.on("click", (function(_item) {
                    return function() {
                        self.publishEvent("VFSController", "show-directory-list", {path : _path + _item.name});
                    };
                }(item)));
            } else {
                const dotIndex = itemName.lastIndexOf(".");
                const fileSuffix = (dotIndex === -1) ? "file" : itemName.substr(dotIndex + 1).toLowerCase();
                $item.attr("data-filetype", fileSuffix);

                $item.on("click", (function(_item) {
                    return function() {
                        self.publishEvent("VFSController", "show-file-actions", {
                            file : _item,
                            path : _path + _item.name
                        });
                    };
                }(item)));
            }

            isEmpty = false;
            $listview.append($item);
        }

        // If there is nothing to show, inform the user
        $emptyDirMessage.toggle(!append && isEmpty);

        if ($listview.hasClass("ui-listview")) {
            $listview.listview().listview("refresh");
        }
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "vfs";
    };

    /**
        * Empties the contents of this view
        */
    this.clearContents = function() {
        $listview.empty();
        $emptyDirMessage.hide();
    };
}

VFSDirectoryListView.prototype = AbstractView;

module.exports = VFSDirectoryListView;